module.exports = __webpack_public_path__ + "img/competition-mmu-2018.b8d79f39.png";